import clsx from 'clsx';

import { TSource } from '@northladder/services';

import {
  BankNoteClockIcon,
  BankNoteCheckMarkIcon,
  DeliveryClockIcon,
  FileReceivedIcon,
  PenLineIcon,
  QuoteAcceptedIcon,
  QuoteRejectedIcon,
} from '../icons';

import { TStatus } from './types';

export interface IRecordIconIdentifierContainerProps {
  source: TSource;
  status: TStatus;
}

/**
 * -----------------------------------------------------------------------------
 * It renders a rounded container with a single icon based on status
 */
export function RecordIconIdentifierContainer({
  source,
  status,
}: Readonly<IRecordIconIdentifierContainerProps>) {
  const activeClassNames =
    source === 'user-active' ? 'opacity-100' : 'opacity-50';

  let element = <div />;

  switch (status) {
    case 'quote-requested':
      element = <PenLineIcon className="w-6" />;
      break;

    case 'quote-received':
      element = <FileReceivedIcon className="w-6" />;
      break;

    case 'pickup-scheduled':
      element = <DeliveryClockIcon className="w-6" />;
      break;

    case 'quote-accepted':
      element = <QuoteAcceptedIcon className="w-6 text-green-700" />;
      break;

    case 'quote-rejected':
      element = <QuoteRejectedIcon className="w-6 text-red-700" />;
      break;

    case 'payment-pending':
      element = <BankNoteClockIcon className="w-6" />;
      break;

    case 'payment-done':
      element = <BankNoteCheckMarkIcon className="w-6 text-green-700" />;
      break;

    default:
      element = <div />;
  }

  return (
    <div
      className={clsx(
        'flex h-10 w-10 items-center justify-center rounded-full border',
        'border-gray-400 bg-gray-50 text-gray-800',
        activeClassNames
      )}
    >
      {element}
    </div>
  );
}
